import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message, Checkbox} from 'semantic-ui-react';

import { WEBSITE_TERMS_AND_CONDITIONS } from '../../../constants';

class FormsRegisterTou extends Component {
    state = {
        agreeToTerms: false
    }
    handleAgreeChange = () => {
        this.setState({ agreeToTerms: !this.state.agreeToTerms })
    }
    render() {
        const {updateStepIndex} = this.props;
        return (
            <Segment>
                <Header as='h2'>
                    Terms and Conditions
                </Header>
                <Divider />
                <Message warning>
                    <Message.Header>
                        Welcome to GroupCare@Income!
                    </Message.Header>
                    <p>
                        Please review the Terms and Conditions before using this application.
                    </p>
                    <Checkbox 
                        label='I hereby agree to the Terms and Conditions and that the information provided here is correct.' 
                        onChange={this.handleAgreeChange}
                        checked={this.state.agreeToTerms}
                    />
                </Message>
                <iframe
                    src={WEBSITE_TERMS_AND_CONDITIONS} 
                    width="100%"
                    height="250"
                    title="Terms and Conditions"
                />
                &nbsp;
                <Button 
                    primary 
                    fluid 
                    onClick={() => updateStepIndex(2)}
                    disabled={!this.state.agreeToTerms}
                >
                    Next
                </Button>
            </Segment>
        );
    }
}

export default FormsRegisterTou;